import natalia from '../../images/team-photos/natalia.jpg';
import hamid from '../../images/team-photos/hamid.jpg';
import adel from '../../images/team-photos/adel.jpg'
import abdulmajeed from '../../images/team-photos/abdulmajeed.jpg'

const teamData = [
    {
        name: "Hamid",
        id: "hamid",
        position: "Team Lead",
        photo: hamid,
        links: [
            {
                name: "github",
                href: "https://github.com/Hamidswed",
                icon: "#icon-github"
            },
            {
                name: "linkedin",
                href: "https://www.linkedin.com/in/hamidreza-delshad/",
                icon: "#icon-linkedin"
              }
        ]
    },
    {
        name: "Natalia Polovynko",
        id: "natalia",
        position: "Full-Stack Developer",
        photo: natalia,
        links: [
            {
                name: "github",
                href: "https://github.com/Afrikanochka",
                icon: "#icon-github"
            },
            {
                name: "linkedin",
                href: "https://www.linkedin.com/in/natalia-polovynko-13660321b/",
                icon: "#icon-linkedin"
              }
        ]
    },
    {
        name: "Adel Ansari",
        id: "adel",
        position: "Full-Stack Developer",
        photo: adel,
        links: [
            {
                name: "github",
                href: "https://github.com/adelansari",
                icon: "#icon-github"
            },
            {
                name: "linkedin",
                href: "https://www.linkedin.com/in/adel-ansari/",
                icon: "#icon-linkedin"
              }
        ]
    },
    {
        name: "Abdulmajeed Altassan",
        id: "abdulmajeed",
        position: "Full-Stack Developer",
        photo: abdulmajeed,
        links: [
            {
                name: "github",
                href: "https://github.com/abdulmajeedoivan",
                icon: "#icon-github"
            },
            {
                name: "linkedin",
                href: "https://www.linkedin.com/in/abdulmajeed-altassan-96364b155",
                icon: "#icon-linkedin"
              }
        ]
    }
]

export default teamData;